require('./common')
require('./images/logo.png')
require('./images/radar_legend.png')
const auth0Client = require('@auth0/auth0-spa-js')

window.addEventListener('error', function(event) {
  console.error('Global Error:', event.message, 'at', event.filename + ':' + event.lineno + ':' + event.colno);
  showGlobalError('Error: ' + event.message + '<br>at ' + event.filename + ':' + event.lineno + ':' + event.colno);
});

window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled Promise Rejection:', event.reason);
  showGlobalError('Unhandled Promise Rejection: ' + (event.reason && event.reason.message ? event.reason.message : event.reason));
});

function showGlobalError(message) {
  let errorDiv = document.getElementById('global-error-handler');
  if (!errorDiv) {
    errorDiv = document.createElement('div');
    errorDiv.id = 'global-error-handler';
    errorDiv.style.position = 'fixed';
    errorDiv.style.top = '0';
    errorDiv.style.left = '0';
    errorDiv.style.width = '100%';
    errorDiv.style.background = 'rgba(200,0,0,0.9)';
    errorDiv.style.color = 'white';
    errorDiv.style.zIndex = '9999';
    errorDiv.style.padding = '16px';
    errorDiv.style.fontSize = '16px';
    errorDiv.style.textAlign = 'center';
    errorDiv.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    document.body.appendChild(errorDiv);
  }
  errorDiv.innerHTML = message;
}
const WorldKinectEnvironment = require('../src/world-kinect/utils/environment')
const radarAuth0Config = WorldKinectEnvironment.getRadarAuth0Config()

const RadarBuilder = require('./util/factory')

if (WorldKinectEnvironment.isLocalhostEnvironment()) {
  RadarBuilder().build()
} else {
  const auth0 = new auth0Client.Auth0Client(radarAuth0Config)

  auth0.getTokenSilently().then(
    (result) => {
      RadarBuilder().build()
    },
    (error) => {
      console.log('Authentication error:', error)
      auth0.loginWithRedirect({
        redirect_uri: window.location.origin,
      })
    },
  )
}
